module.exports = __webpack_public_path__ + "img/vid.2b2637bb.svg";